import React, { memo, useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { getCountdown } from "../helper/Countdown";
import toast from "react-hot-toast";
import { BsArrowRight } from "react-icons/bs";

const DealsOne = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetch("/assets/data/products.json")
      .then((res) => res.json())
      .then((data) => {
        const filtered = data.filter(
          (item) =>
            item.category &&
            (item.category.toLowerCase().includes("laser") ||
              item.category.toLowerCase().includes("inkjet"))
        );
        setProducts(filtered);
      })
      .catch((err) => console.error("Error loading products:", err));
  }, []);

  const [timeLeft, setTimeLeft] = useState(getCountdown());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getCountdown());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1599,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // ✅ Add to Cart Handler
  const handleAddToCart = (product) => {
    const isLoggedIn = sessionStorage.getItem("isLoggedIn");

    if (isLoggedIn !== "true") {
      toast.error("Please login first!");
      navigate("/login");
      return;
    }

    let cart = JSON.parse(sessionStorage.getItem("cart")) || [];
    const existing = cart.find((item) => item.id === product.id);

    if (existing) {
      existing.quantity += 1;
    } else {
      cart.push({ ...product, quantity: 1 });
    }

    sessionStorage.setItem("cart", JSON.stringify(cart));
    toast.success(`${product.name} added to cart!`);
  };

  // ✅ Generate random values only once per mount (NOT every render)
  const productsWithRandomData = useMemo(() => {
    return products.map((item) => {
      const total = Math.floor(Math.random() * 50) + 10;
      const sold = Math.floor(Math.random() * total);
      const percent = Math.round((sold / total) * 100);
      const rating = (Math.random() * 1 + 4).toFixed(1);
      const reviews = Math.floor(Math.random() * 9000) + 1000;
      return { ...item, total, sold, percent, rating, reviews };
    });
  }, [products]);

  return (
    <section className="deals-weeek pt-80 sec-grey">
      <div className="container container-lg">
        <div className="border border-gray-100 p-24 rounded-16">
          {/* Slider Section */}
          <div className="deals-week-slider arrow-style-two mb-30">
            <div className="mt-30 py-10 mb-30 text-center">
              <h4
                style={{
                  fontSize: "32px",
                  fontWeight: "700",
                  color: "#222",
                  marginBottom: "10px",
                }}
              >
                Best Laser Printers & Ink Cartridge Deals
              </h4>
              <p
                style={{
                  color: "#555",
                  fontSize: "15px",
                  maxWidth: "700px",
                  margin: "0 auto",
                  lineHeight: "1.7",
                }}
              >
                Discover unbeatable prices on top-rated printers and genuine
                cartridges. Experience smoother, faster, and high-quality
                printing for your home and office with Printing Dealz.
              </p>
            </div>

            <Slider {...settings}>
              {productsWithRandomData.map((item) => (
                <div key={item.id}>
                  <div
                    style={{
                      position: "relative",
                      background: "#fff",
                      borderRadius: "18px",
                      padding: "25px 25px 70px 25px",
                      overflow: "hidden",
                      transition: "all 0.4s ease",
                      height: "480px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-10px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    <Link
                      to={`/product/${item.id}`}
                      style={{
                        position: "relative",
                        textAlign: "center",
                        marginBottom: "15px",
                      }}
                    >
                      <img
                        src={
                          item.imageUrl ||
                          "/assets/images/thumbs/product-two-img1.png"
                        }
                        alt={item.name}
                        style={{
                          width: "180px",
                          height: "160px",
                          objectFit: "contain",
                          transition: "transform 0.4s ease",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.transform =
                            "translateY(-10px)")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.transform = "translateY(0)")
                        }
                      />

                      <span
                        style={{
                          position: "absolute",
                          top: "10px",
                          left: "10px",
                          background: "#3446b8",
                          color: "#fff",
                          padding: "3px 10px",
                          borderRadius: "12px",
                          fontSize: "12px",
                          fontWeight: "600",
                        }}
                      >
                        🔥 Hot Deal
                      </span>
                    </Link>

                    <h5
                      style={{
                        fontSize: "17px",
                        fontWeight: "700",
                        color: "#111",
                        textAlign: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <Link
                        to={`/product/${item.id}`}
                        className="link text-line-2"
                      >
                        {item.name}
                      </Link>
                    </h5>

                    <div className="product-card__content mt-16">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "6px",
                          marginBottom: "10px",
                        }}
                      >
                        <i
                          className="ph-fill ph-star"
                          style={{ color: "#ffb400" }}
                        />

                        <span style={{ fontSize: "14px", color: "#555" }}>
                          {item.rating}
                        </span>

                        <span style={{ fontSize: "12px", color: "#777" }}>
                          ({item.reviews.toLocaleString()} reviews)
                        </span>
                      </div>

                      {/* Progress */}
                      <div
                        style={{
                          background: "#f1f1f1",
                          borderRadius: "20px",
                          height: "6px",
                          overflow: "hidden",
                          margin: "10px 20px",
                        }}
                      >
                        <div
                          style={{
                            width: `${item.percent}%`,
                            background: "#3446b8",
                            height: "100%",
                            borderRadius: "20px",
                            transition: "width 0.4s ease",
                          }}
                        />
                      </div>
                      <p
                        style={{
                          fontSize: "12px",
                          color: "#666",
                          textAlign: "center",
                          marginBottom: "10px",
                        }}
                      >
                        Sold: {item.sold}/{item.total}
                      </p>

                      {/* Price */}
                      <div
                        style={{
                          textAlign: "center",
                          marginBottom: "10px",
                        }}
                      >
                        {item.oldPrice && (
                          <span
                            style={{
                              color: "#999",
                              textDecoration: "line-through",
                              fontSize: "14px",
                              marginRight: "6px",
                            }}
                          >
                            ${item.oldPrice}
                          </span>
                        )}
                        <span
                          style={{
                            fontSize: "20px",
                            fontWeight: "700",
                            color: "#222",
                          }}
                        >
                          ${item.price}
                        </span>
                        <span
                          style={{
                            color: "#777",
                            fontWeight: "400",
                            fontSize: "13px",
                            marginLeft: "4px",
                          }}
                        >
                          /Qty
                        </span>
                      </div>

                      {/* Footer Gradient Bar */}
                      <div
                        style={{
                          position: "absolute",
                          bottom: "0",
                          left: "0",
                          width: "100%",
                          background: "#3446b8",
                          color: "#fff",
                          padding: "12px 20px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          borderBottomLeftRadius: "18px",
                          borderBottomRightRadius: "18px",
                        }}
                      >
                        <button
                          onClick={() => {
                            handleAddToCart(item);
                            window.location.reload();
                          }}
                          type="button"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                            border: "none",
                            color: "#fff",
                            fontWeight: "600",
                            borderRadius: "50px",
                            padding: "10px 20px",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            width: "100%",
                            background: "transparent",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform =
                              "translateY(-2px)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 10px rgba(0,0,0,0.2)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <span style={{ fontWeight: "600" }}>Add To Cart</span>
                          <span>
                            <i
                              className="ph ph-shopping-cart"
                              style={{ fontSize: "18px" }}
                            />
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>

          <div className="section-heading mt-30">
            <div className="d-flex justify-content-between flex-wrap gap-3 align-items-center">
              <h5 className="mb-0 fw-bold">Shop By Category</h5>
              <div>
                <Link
                  to="/shop"
                  className="btn btn-outline-dark d-inline-flex align-items-center gap-2"
                >
                  View Products
                </Link>
              </div>
            </div>
          </div>

          <div style={{ marginTop: "30px", marginBottom: "30px" }}>
            <div className="row g-4">
              {/* Card 1 */}
              <div className="col-sm-3">
                <div className="category-card">
                  <Link to="/home-printers" className="category-thumb">
                    <img
                      src="assets/images/thumbs/home-printer.jpg"
                      alt="Home Printers"
                    />
                  </Link>
                  <div className="category-content mt-20">
                    <h6 className="fw-semibold mb-2">
                      <Link to="/home-printers" className="text-dark">
                        Home Printers
                      </Link>
                    </h6>
                    <Link
                      to="/home-printers"
                      className="shop-now text-danger fw-semibold"
                    >
                      Shop Now <BsArrowRight />
                    </Link>
                  </div>
                </div>
              </div>

              {/* Card 2 */}
              <div className="col-sm-3">
                <div className="category-card">
                  <Link to="/office-printers" className="category-thumb">
                    <img
                      src="assets/images/thumbs/office-printer.jpg"
                      alt="Office Printers"
                    />
                  </Link>
                  <div className="category-content mt-20">
                    <h6 className="fw-semibold mb-2">
                      <Link to="/office-printers" className="text-dark">
                        Office Printers
                      </Link>
                    </h6>
                    <Link
                      to="/office-printers"
                      className="shop-now text-danger fw-semibold"
                    >
                      Shop Now <BsArrowRight />
                    </Link>
                  </div>
                </div>
              </div>

              {/* Card 3 */}
              <div className="col-sm-3">
                <div className="category-card">
                  <Link to="/inkjet-printers" className="category-thumb">
                    <img
                      src="assets/images/thumbs/inkjet-printer.jpg"
                      alt="Inkjet Printers"
                    />
                  </Link>
                  <div className="category-content mt-20">
                    <h6 className="fw-semibold mb-2">
                      <Link to="/inkjet-printers" className="text-dark">
                        Inkjet Printers
                      </Link>
                    </h6>
                    <Link
                      to="/inkjet-printers"
                      className="shop-now text-danger fw-semibold"
                    >
                      Shop Now <BsArrowRight />
                    </Link>
                  </div>
                </div>
              </div>

              {/* Card 4 */}
              <div className="col-sm-3">
                <div className="category-card">
                  <Link to="/laser-printers" className="category-thumb">
                    <img
                      src="assets/images/thumbs/laser-printer.jpg"
                      alt="Laser Printers"
                    />
                  </Link>
                  <div className="category-content mt-20">
                    <h6 className="fw-semibold mb-2">
                      <Link to="/laser-printers" className="text-dark">
                        Laser Printers
                      </Link>
                    </h6>
                    <Link
                      to="/laser-printers"
                      className="shop-now text-danger fw-semibold"
                    >
                      Shop Now <BsArrowRight />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DealsOne;
